// import { useState, useEffect } from "react";
// import { BASE_URL } from "../Config";

// const TIERS = [
//   { milestone: 25,  tier: "Basic",    bonusMonths: 1,  color: "#CD7F32", bg: "#FFF8F0", border: "#E8A96A" },
//   { milestone: 50,  tier: "Silver",   bonusMonths: 2,  color: "#6B7280", bg: "#F8F9FA", border: "#9CA3AF" },
//   { milestone: 75,  tier: "Gold",     bonusMonths: 3,  color: "#B8860B", bg: "#FFFBEB", border: "#D4A017" },
//   { milestone: 100, tier: "Diamond",  bonusMonths: 5,  color: "#0EA5E9", bg: "#F0F9FF", border: "#38BDF8" },
//   { milestone: 200, tier: "Platinum", bonusMonths: 6,  color: "#7C3AED", bg: "#F5F3FF", border: "#A78BFA" },
// ];

// const TIER_ICONS = {
//   Basic:    "◆",
//   Silver:   "◈",
//   Gold:     "★",
//   Diamond:  "◇",
//   Platinum: "✦",
// };

// function AwardBadge({ award, earned }) {
//   return (
//     <div style={{
//       display: "flex",
//       flexDirection: "column",
//       alignItems: "center",
//       gap: "6px",
//       opacity: earned ? 1 : 0.35,
//       transition: "opacity 0.3s",
//     }}>
//       <div style={{
//         width: "52px",
//         height: "52px",
//         borderRadius: "50%",
//         background: earned ? award.bg : "#F3F4F6",
//         border: `2px solid ${earned ? award.border : "#E5E7EB"}`,
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         fontSize: "22px",
//         color: earned ? award.color : "#D1D5DB",
//         transition: "all 0.3s",
//         position: "relative",
//       }}>
//         {TIER_ICONS[award.tier]}
//         {earned && (
//           <div style={{
//             position: "absolute",
//             bottom: "-2px",
//             right: "-2px",
//             width: "16px",
//             height: "16px",
//             borderRadius: "50%",
//             background: "#22C55E",
//             border: "2px solid white",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             fontSize: "9px",
//             color: "white",
//             fontWeight: 700,
//           }}>✓</div>
//         )}
//       </div>
//       <span style={{
//         fontSize: "11px",
//         fontWeight: 600,
//         color: earned ? award.color : "#9CA3AF",
//         letterSpacing: "0.04em",
//         textTransform: "uppercase",
//       }}>{award.tier}</span>
//       <span style={{
//         fontSize: "10px",
//         color: "#9CA3AF",
//         whiteSpace: "nowrap",
//       }}>{award.milestone} images</span>
//     </div>
//   );
// }

// export default function CreatorAwards() {
//   const [data, setData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const token = sessionStorage.getItem("token");
//     fetch(`${BASE_URL}/creator-awards/my-progress`, {
//       headers: { Authorization: `Bearer ${token}` },
//     })
//       .then((r) => r.json())
//       .then((res) => {
//         setData(res);
//         setLoading(false);
//       })
//       .catch(() => {
//         setError("Could not load awards");
//         setLoading(false);
//       });
//   }, []);

//   if (loading) {
//     return (
//       <div style={cardStyle}>
//         <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
//           {[1, 2, 3].map((i) => (
//             <div key={i} style={{
//               height: "20px",
//               borderRadius: "6px",
//               background: "linear-gradient(90deg, #F3F4F6 25%, #E5E7EB 50%, #F3F4F6 75%)",
//               backgroundSize: "200% 100%",
//               animation: "shimmer 1.5s infinite",
//               opacity: 1 - i * 0.2,
//             }} />
//           ))}
//         </div>
//         <style>{`@keyframes shimmer { 0%{background-position:200% 0} 100%{background-position:-200% 0} }`}</style>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div style={{ ...cardStyle, textAlign: "center", color: "#EF4444", fontSize: "14px" }}>
//         {error}
//       </div>
//     );
//   }

//   const approvedCount = data?.approvedCount ?? 0;
//   const grantedMilestones = (data?.grantedAwards ?? []).map((a) => a.milestone);
//   const nextAward = data?.nextAward ?? null;
//   const imagesUntilNext = data?.imagesUntilNext ?? 0;

//   // Progress bar: between last earned and next milestone
//   const lastEarned = grantedMilestones.length > 0
//     ? Math.max(...grantedMilestones)
//     : 0;
//   const progressStart = lastEarned;
//   const progressEnd = nextAward?.milestone ?? 200;
//   const progressPct = nextAward
//     ? Math.min(100, ((approvedCount - progressStart) / (progressEnd - progressStart)) * 100)
//     : 100;

//   const nextTier = TIERS.find((t) => t.milestone === nextAward?.milestone);

//   return (
//     <div style={cardStyle}>
//       {/* Header */}
//       <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "20px" }}>
//         <div>
//           <h3 style={{ margin: 0, fontSize: "16px", fontWeight: 700, color: "#111827", letterSpacing: "-0.01em" }}>
//             Creator Awards
//           </h3>
//           <p style={{ margin: "2px 0 0", fontSize: "13px", color: "#6B7280" }}>
//             {approvedCount} approved image{approvedCount !== 1 ? "s" : ""}
//           </p>
//         </div>
//         {grantedMilestones.length > 0 && (
//           <div style={{
//             background: "#F0FDF4",
//             border: "1px solid #BBF7D0",
//             borderRadius: "20px",
//             padding: "4px 12px",
//             fontSize: "12px",
//             fontWeight: 600,
//             color: "#16A34A",
//           }}>
//             {grantedMilestones.length} earned
//           </div>
//         )}
//       </div>

//       {/* Badges row */}
//       <div style={{
//         display: "flex",
//         justifyContent: "space-between",
//         alignItems: "flex-start",
//         marginBottom: "24px",
//         padding: "16px",
//         background: "#FAFAFA",
//         borderRadius: "12px",
//         border: "1px solid #F3F4F6",
//       }}>
//         {TIERS.map((award) => (
//           <AwardBadge
//             key={award.milestone}
//             award={award}
//             earned={grantedMilestones.includes(award.milestone)}
//           />
//         ))}
//       </div>

//       {/* Progress bar */}
//       {nextAward ? (
//         <div style={{ marginBottom: "20px" }}>
//           <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "8px" }}>
//             <span style={{ fontSize: "13px", color: "#374151", fontWeight: 500 }}>
//               Next: {nextTier?.tier} Award
//             </span>
//             <span style={{ fontSize: "12px", color: "#6B7280" }}>
//               {imagesUntilNext} more image{imagesUntilNext !== 1 ? "s" : ""} to go
//             </span>
//           </div>
//           <div style={{
//             height: "8px",
//             background: "#F3F4F6",
//             borderRadius: "99px",
//             overflow: "hidden",
//           }}>
//             <div style={{
//               height: "100%",
//               width: `${progressPct}%`,
//               background: nextTier ? `linear-gradient(90deg, ${nextTier.border}, ${nextTier.color})` : "#6B7280",
//               borderRadius: "99px",
//               transition: "width 1s cubic-bezier(0.34, 1.56, 0.64, 1)",
//             }} />
//           </div>
//           <div style={{ display: "flex", justifyContent: "space-between", marginTop: "6px" }}>
//             <span style={{ fontSize: "11px", color: "#9CA3AF" }}>{progressStart} images</span>
//             <span style={{ fontSize: "11px", color: "#9CA3AF" }}>{progressEnd} images</span>
//           </div>
//         </div>
//       ) : (
//         <div style={{
//           textAlign: "center",
//           padding: "12px",
//           background: "#F5F3FF",
//           borderRadius: "10px",
//           marginBottom: "20px",
//           border: "1px solid #DDD6FE",
//         }}>
//           <span style={{ fontSize: "13px", fontWeight: 600, color: "#7C3AED" }}>
//             ✦ All awards earned! Platinum Creator achieved.
//           </span>
//         </div>
//       )}

//       {/* Milestones table */}
//       <div style={{ borderRadius: "10px", overflow: "hidden", border: "1px solid #F3F4F6" }}>
//         <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13px" }}>
//           <thead>
//             <tr style={{ background: "#F9FAFB" }}>
//               <th style={thStyle}>Tier</th>
//               <th style={thStyle}>Images</th>
//               <th style={thStyle}>Bonus</th>
//               <th style={{ ...thStyle, textAlign: "right" }}>Status</th>
//             </tr>
//           </thead>
//           <tbody>
//             {TIERS.map((award, i) => {
//               const earned = grantedMilestones.includes(award.milestone);
//               const isCurrent = nextAward?.milestone === award.milestone;
//               return (
//                 <tr key={award.milestone} style={{
//                   background: isCurrent ? award.bg : "white",
//                   borderTop: i > 0 ? "1px solid #F3F4F6" : "none",
//                 }}>
//                   <td style={{ ...tdStyle, display: "flex", alignItems: "center", gap: "8px" }}>
//                     <span style={{ color: award.color, fontSize: "15px" }}>{TIER_ICONS[award.tier]}</span>
//                     <span style={{ fontWeight: 600, color: "#111827" }}>{award.tier}</span>
//                   </td>
//                   <td style={tdStyle}>{award.milestone}</td>
//                   <td style={{ ...tdStyle, color: "#059669", fontWeight: 500 }}>+{award.bonusMonths} mo.</td>
//                   <td style={{ ...tdStyle, textAlign: "right" }}>
//                     {earned ? (
//                       <span style={{
//                         background: "#F0FDF4", color: "#16A34A",
//                         border: "1px solid #BBF7D0",
//                         borderRadius: "99px", padding: "2px 10px",
//                         fontSize: "11px", fontWeight: 600,
//                       }}>Earned</span>
//                     ) : isCurrent ? (
//                       <span style={{
//                         background: award.bg, color: award.color,
//                         border: `1px solid ${award.border}`,
//                         borderRadius: "99px", padding: "2px 10px",
//                         fontSize: "11px", fontWeight: 600,
//                       }}>Next</span>
//                     ) : approvedCount >= award.milestone ? (
//                       <span style={{
//                         background: "#F0FDF4", color: "#16A34A",
//                         border: "1px solid #BBF7D0",
//                         borderRadius: "99px", padding: "2px 10px",
//                         fontSize: "11px", fontWeight: 600,
//                       }}>Earned</span>
//                     ) : (
//                       <span style={{ color: "#D1D5DB", fontSize: "11px" }}>{award.milestone - approvedCount} away</span>
//                     )}
//                   </td>
//                 </tr>
//               );
//             })}
//           </tbody>
//         </table>
//       </div>

//       {nextAward && (
//         <p style={{ margin: "12px 0 0", fontSize: "12px", color: "#9CA3AF", textAlign: "center" }}>
//           Reaching {nextAward.milestone} approved images grants +{nextAward.bonusMonths} month{nextAward.bonusMonths > 1 ? "s" : ""} bonus extension
//         </p>
//       )}
//     </div>
//   );
// }

// const cardStyle = {
//   background: "white",
//   borderRadius: "16px",
//   border: "1px solid #E5E7EB",
//   padding: "24px",
//   fontFamily: "'DM Sans', sans-serif",
// };

// const thStyle = {
//   padding: "10px 14px",
//   textAlign: "left",
//   fontSize: "11px",
//   fontWeight: 600,
//   color: "#6B7280",
//   textTransform: "uppercase",
//   letterSpacing: "0.06em",
// };

// const tdStyle = {
//   padding: "11px 14px",
//   color: "#374151",
// };

import { useState, useEffect } from "react";
import { BASE_URL } from "../Config";

const TIERS = [
  { milestone: 25,  tier: "Basic",    bonusMonths: 1,  color: "#CD7F32", bg: "#FFF8F0", border: "#E8A96A" },
  { milestone: 50,  tier: "Silver",   bonusMonths: 2,  color: "#6B7280", bg: "#F8F9FA", border: "#9CA3AF" },
  { milestone: 75,  tier: "Gold",     bonusMonths: 3,  color: "#B8860B", bg: "#FFFBEB", border: "#D4A017" },
  { milestone: 100, tier: "Diamond",  bonusMonths: 5,  color: "#0EA5E9", bg: "#F0F9FF", border: "#38BDF8" },
  { milestone: 200, tier: "Platinum", bonusMonths: 6,  color: "#7C3AED", bg: "#F5F3FF", border: "#A78BFA" },
];

const TIER_ICONS = {
  Basic:    "◆",
  Silver:   "◈",
  Gold:     "★",
  Diamond:  "◇",
  Platinum: "✦",
};

function AwardBadge({ award, earned }) {
  return (
    <div style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "6px",
      opacity: earned ? 1 : 0.35,
      transition: "opacity 0.3s",
    }}>
      <div style={{
        width: "52px",
        height: "52px",
        borderRadius: "50%",
        background: earned ? award.bg : "#F3F4F6",
        border: `2px solid ${earned ? award.border : "#E5E7EB"}`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "22px",
        color: earned ? award.color : "#D1D5DB",
        transition: "all 0.3s",
        position: "relative",
      }}>
        {TIER_ICONS[award.tier]}
        {earned && (
          <div style={{
            position: "absolute",
            bottom: "-2px",
            right: "-2px",
            width: "16px",
            height: "16px",
            borderRadius: "50%",
            background: "#22C55E",
            border: "2px solid white",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "9px",
            color: "white",
            fontWeight: 700,
          }}>✓</div>
        )}
      </div>
      <span style={{
        fontSize: "11px",
        fontWeight: 600,
        color: earned ? award.color : "#9CA3AF",
        letterSpacing: "0.04em",
        textTransform: "uppercase",
      }}>{award.tier}</span>
      <span style={{
        fontSize: "10px",
        color: "#9CA3AF",
        whiteSpace: "nowrap",
      }}>{award.milestone} images</span>
    </div>
  );
}

export default function CreatorAwards() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const token = sessionStorage.getItem("token");
    fetch(`${BASE_URL}/creator-awards/my-progress`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((r) => r.json())
      .then((res) => {
        setData(res);
        setLoading(false);
      })
      .catch(() => {
        setError("Could not load awards");
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <div>
        <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          {[1, 2, 3].map((i) => (
            <div key={i} style={{
              height: "20px",
              borderRadius: "6px",
              background: "linear-gradient(90deg, #F3F4F6 25%, #E5E7EB 50%, #F3F4F6 75%)",
              backgroundSize: "200% 100%",
              animation: "shimmer 1.5s infinite",
              opacity: 1 - i * 0.2,
            }} />
          ))}
        </div>
        <style>{`@keyframes shimmer { 0%{background-position:200% 0} 100%{background-position:-200% 0} }`}</style>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ textAlign: "center", color: "#EF4444", fontSize: "14px" }}>
        {error}
      </div>
    );
  }

  const approvedCount = data?.approvedCount ?? 0;
  const grantedMilestones = (data?.grantedAwards ?? []).map((a) => a.milestone);
  const nextAward = data?.nextAward ?? null;
  const imagesUntilNext = data?.imagesUntilNext ?? 0;

  const lastEarned = grantedMilestones.length > 0 ? Math.max(...grantedMilestones) : 0;
  const progressStart = lastEarned;
  const progressEnd = nextAward?.milestone ?? 200;
  const progressPct = nextAward
    ? Math.min(100, ((approvedCount - progressStart) / (progressEnd - progressStart)) * 100)
    : 100;

  const nextTier = TIERS.find((t) => t.milestone === nextAward?.milestone);

  return (
    <div style={{ fontFamily: "'DM Sans', sans-serif" }}>
      {/* Header */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "20px" }}>
        <div>
          <h3 style={{ margin: 0, fontSize: "16px", fontWeight: 700, color: "#111827", letterSpacing: "-0.01em" }}>
            🏆 Creator Awards
          </h3>
          <p style={{ margin: "2px 0 0", fontSize: "13px", color: "#6B7280" }}>
            {approvedCount} approved image{approvedCount !== 1 ? "s" : ""}
          </p>
        </div>
        {grantedMilestones.length > 0 && (
          <div style={{
            background: "#F0FDF4",
            border: "1px solid #BBF7D0",
            borderRadius: "20px",
            padding: "4px 12px",
            fontSize: "12px",
            fontWeight: 600,
            color: "#16A34A",
          }}>
            {grantedMilestones.length} earned
          </div>
        )}
      </div>

      {/* Badges row */}
      <div style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        marginBottom: "24px",
        padding: "16px",
        background: "#FAFAFA",
        borderRadius: "12px",
        border: "1px solid #F3F4F6",
      }}>
        {TIERS.map((award) => (
          <AwardBadge
            key={award.milestone}
            award={award}
            earned={grantedMilestones.includes(award.milestone)}
          />
        ))}
      </div>

      {/* Progress bar */}
      {nextAward ? (
        <div style={{ marginBottom: "20px" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "8px" }}>
            <span style={{ fontSize: "13px", color: "#374151", fontWeight: 500 }}>
              Next: {nextTier?.tier} Award
            </span>
            <span style={{ fontSize: "12px", color: "#6B7280" }}>
              {imagesUntilNext} more image{imagesUntilNext !== 1 ? "s" : ""} to go
            </span>
          </div>
          <div style={{
            height: "8px",
            background: "#F3F4F6",
            borderRadius: "99px",
            overflow: "hidden",
          }}>
            <div style={{
              height: "100%",
              width: `${progressPct}%`,
              background: nextTier ? `linear-gradient(90deg, ${nextTier.border}, ${nextTier.color})` : "#6B7280",
              borderRadius: "99px",
              transition: "width 1s cubic-bezier(0.34, 1.56, 0.64, 1)",
            }} />
          </div>
          <div style={{ display: "flex", justifyContent: "space-between", marginTop: "6px" }}>
            <span style={{ fontSize: "11px", color: "#9CA3AF" }}>{progressStart} images</span>
            <span style={{ fontSize: "11px", color: "#9CA3AF" }}>{progressEnd} images</span>
          </div>
        </div>
      ) : (
        <div style={{
          textAlign: "center",
          padding: "12px",
          background: "#F5F3FF",
          borderRadius: "10px",
          marginBottom: "20px",
          border: "1px solid #DDD6FE",
        }}>
          <span style={{ fontSize: "13px", fontWeight: 600, color: "#7C3AED" }}>
            ✦ All awards earned! Platinum Creator achieved.
          </span>
        </div>
      )}

      {/* Milestones table */}
      <div style={{ borderRadius: "10px", overflow: "hidden", border: "1px solid #F3F4F6" }}>
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13px" }}>
          <thead>
            <tr style={{ background: "#F9FAFB" }}>
              <th style={thStyle}>Tier</th>
              <th style={thStyle}>Images</th>
              <th style={thStyle}>Bonus</th>
              <th style={{ ...thStyle, textAlign: "right" }}>Status</th>
            </tr>
          </thead>
          <tbody>
            {TIERS.map((award, i) => {
              const earned = grantedMilestones.includes(award.milestone);
              const isCurrent = nextAward?.milestone === award.milestone;
              return (
                <tr key={award.milestone} style={{
                  background: isCurrent ? award.bg : "white",
                  borderTop: i > 0 ? "1px solid #F3F4F6" : "none",
                }}>
                  <td style={{ ...tdStyle, display: "flex", alignItems: "center", gap: "8px" }}>
                    <span style={{ color: award.color, fontSize: "15px" }}>{TIER_ICONS[award.tier]}</span>
                    <span style={{ fontWeight: 600, color: "#111827" }}>{award.tier}</span>
                  </td>
                  <td style={tdStyle}>{award.milestone}</td>
                  <td style={{ ...tdStyle, color: "#059669", fontWeight: 500 }}>+{award.bonusMonths} mo.</td>
                  <td style={{ ...tdStyle, textAlign: "right" }}>
                    {earned ? (
                      <span style={{
                        background: "#F0FDF4", color: "#16A34A",
                        border: "1px solid #BBF7D0",
                        borderRadius: "99px", padding: "2px 10px",
                        fontSize: "11px", fontWeight: 600,
                      }}>Earned</span>
                    ) : isCurrent ? (
                      <span style={{
                        background: award.bg, color: award.color,
                        border: `1px solid ${award.border}`,
                        borderRadius: "99px", padding: "2px 10px",
                        fontSize: "11px", fontWeight: 600,
                      }}>Next</span>
                    ) : approvedCount >= award.milestone ? (
                      <span style={{
                        background: "#F0FDF4", color: "#16A34A",
                        border: "1px solid #BBF7D0",
                        borderRadius: "99px", padding: "2px 10px",
                        fontSize: "11px", fontWeight: 600,
                      }}>Earned</span>
                    ) : (
                      <span style={{ color: "#D1D5DB", fontSize: "11px" }}>{award.milestone - approvedCount} away</span>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {nextAward && (
        <p style={{ margin: "12px 0 0", fontSize: "12px", color: "#9CA3AF", textAlign: "center" }}>
          Reaching {nextAward.milestone} approved images grants +{nextAward.bonusMonths} month{nextAward.bonusMonths > 1 ? "s" : ""} bonus extension
        </p>
      )}
    </div>
  );
}

const thStyle = {
  padding: "10px 14px",
  textAlign: "left",
  fontSize: "11px",
  fontWeight: 600,
  color: "#6B7280",
  textTransform: "uppercase",
  letterSpacing: "0.06em",
};

const tdStyle = {
  padding: "11px 14px",
  color: "#374151",
};